import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 1000px) {
    margin-bottom: 10%;
    height: auto;
  }
`;

export const ContainerArea = styled.div`
  width: 100%;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 10px;
  font-size: 13px;

  .description {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;

    @media (max-width: 1000px) {
      flex-wrap: wrap;
      width: 100%;
      padding: 4% 6%;
    }
  }

  @media (max-width: 1000px) {
    margin-bottom: 5%;
    height: auto;
  }
`;
